import Header from "./components/Header";
import Footer from "../../components/Shared/Footer";

export default function Homepage() {
  return (
    <>
      <Header />
      <main>
        <h1>Kunde 2 Homepage</h1>
      </main>
      <Footer />
    </>
  );
}
